import LogoApp from "../../Styles/img/logo-sgb-app.png";
import GoogleApp from "../../Styles/img/google-play.png";
import AppleApp from "../../Styles/img/app-store.png";
import Icons from "../Icons/Icons";
import {inject, observer} from "mobx-react";
import {Link} from "react-router-dom";

const Footer = (props) => {


    return (
        <footer className={`footer bg--gray10 py--6 mt--6`}>
            <div className="container">
                <div className="bb pb--6 mb--6">
                    <div className="row">
                        {
                            props.Settings.item.footer && props.Settings.item.footer.map((item, key) => (

                                <div className={`col-md-3`} key={`footer${key}`}>
                                    <div className="flex flex--column list py--3">
                                        <h3 className={`h2 pb--4`}>{item.name}</h3>
                                        {
                                            item.child && item.child.map((child, key_child) => {
                                                const isExternal =
                                                    child.url.startsWith('http://') ||
                                                    child.url.startsWith('https://') ||
                                                    child.url.startsWith('www.');

                                                const link = isExternal ? child.url : `/${child.url}`;

                                                return (
                                                    <a
                                                        href={link}
                                                        title={child.name}
                                                        className="list__link flex flex--middle mb--2"
                                                        key={`footer-child${key_child}`}
                                                    >
                                                        {child.name}
                                                    </a>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="flex flex--column flex-md--row flex--between flex--middle py--3">
                    <div className="flex flex--column flex-md--row flex--wrap flex--middle">
                        <h3 className={"h2 mr--6"}>Aplikacja mobilna BS Oława</h3>
                        <img src={LogoApp} alt="Aplikacja mobilna BS Oława" className={"footer__icon my--1 my-md--0"} height="45" loading={"lazy"}/>
                        <a href="https://play.google.com/store/apps/details?id=pl.olawa.naszbank"
                           title={"Google Apps"} className={`mr--3 ml--3  my--1 my-md--0`}>
                            <img src={GoogleApp} alt="Aplikacja mobilna BS Oława" className={"footer__icon"} height="45" loading={"lazy"}/>
                        </a>
                        <a href="https://apps.apple.com/gb/app/bs-o%C5%82awa/id1481179431" className={" my--1 my-md--0"}
                           title={"Apple Store"}>
                            <img src={AppleApp} alt="Aplikacja mobilna BS Oława" className={"footer__icon"} height="45" loading={"lazy"}/>
                        </a>
                    </div>
                    <h3 className={"h2  my--1 my-md--0"}>BIC CODE (SWIFT): GBWCPLPP</h3>
                </div>
                <div className="py--6 mt--6 bt flex flex--column flex-md--row flex--middle flex--between">
                    <div className={`flex flex--column`}>
                        <span>Wszelkie prawa autorskie zastrzeżone.</span>
                        <span className={"py--2"}>Copyright © 2021 Bank Spółdzielczy w Oławie.</span>
                        <span>Projekt i realizacja: <a href={"http://bqstudio.pl"} title={""}>BQstudio.pl</a></span>
                    </div>
                </div>
            </div>

            {
                <div className={`notification alert--error px--4 py--4 ${ props.Notification.error ? `flex` : `none` }`}>{props.Notification.error}</div>
            }
        </footer>
    )

}

export default inject('Settings', 'Notification')(observer(Footer))
